import { computed } from "vue";
import type { Ref } from "vue";
import type { SimulationItem } from "./SimulationItem";

export function useCommonTimeUnits(
  simulations: Ref<{ [id: number]: SimulationItem }>
) {
  return {
    durationType: computed(() => {
      return getCommonSimulationUnit(
        simulations.value,
        "durationType",
        "roundAmount"
      );
    }),
    roundUnit: computed(() => {
      return getCommonSimulationUnit(simulations.value, "roundUnit", "round");
    }),
    roundLength: computed(() => {
      return getCommonSimulationUnit(simulations.value, "roundLength", 1);
    }),
    timeStart: computed(() => {
      return getCommonSimulationUnit(simulations.value, "timeStart", null);
    })
  };
}

function getCommonSimulationUnit<T extends keyof SimulationItem>(
  simulations: { [id: number]: SimulationItem },
  prop: T,
  defaultValue: SimulationItem[T]
) {
  const simArray = Object.values(simulations);
  if (simArray.length == 0) return defaultValue;

  const value = simArray[0][prop];
  for (const sim of simArray) {
    if (sim[prop] != value) return defaultValue;
  }
  return value;
}
